import { NextRouter } from 'next/router';
import qs from 'qs';

import constants from '../../../../../../ahm-constants';

const handleSubmit = <T>(values: T, router: NextRouter) => {
  const queryParams = qs.stringify(values);
  router.push(`${constants.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL}/inbound-quote?${queryParams}`);
};

export default handleSubmit;
